var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src.length > 0)?_c('b-tooltip',{attrs:{"label":_vm.ciService,"position":"is-bottom","type":"is-dark"}},[_c('img',{staticClass:"ci-service-icon",attrs:{"src":_vm.src,"alt":_vm.ciService}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }